export interface PickingListAllocationsReport {
  stockNo: string;
  batch: string;
  balance: number;
  allocated: number;
  picked: number;
  balanceString: number;
  allocatedString: number;
  pickedString: number;
  unit: string;
  warehouse: string;
  location: string;
  remeasureBeforeCutting: boolean;
  reMeasure: boolean;
  reMeasureString: string;
  barcode: string;
}
